<template>
    <VueFinalModal class="modal"
            content-class="modal-content"
            overlay-transition="vfm-fade"
            :clickToClose="false"
            @click-outside="emit('close')">
        <TileCard :loaded="settingsStore.getServicesLoaded" class="tile-card">
            <template #body>
                <TeamPropertiesForm :team="props.team"></TeamPropertiesForm>         
            </template>                
        </TileCard> 
        <div class="buttons">
            <button class="accent" @click="() => emit('close')"x>Accept</button>
        </div>

    </VueFinalModal>
</template>    

<script setup lang="ts">
import { ServiceTeamItem } from '@/services/entities/ServiceTeams/ServiceTeamItem';
import TeamPropertiesForm from '@/components/service_teams/forms/TeamPropertisForm.vue';
import { VueFinalModal } from 'vue-final-modal';
import TileCard from '@/components/util/TileCard.vue';
import { useSettingsStore } from '@/stores/setting';

const settingsStore = useSettingsStore();
const props = defineProps({
    team: { Type: {} as ServiceTeamItem, required: true, default: () => ({} as ServiceTeamItem) },
});

const emit = defineEmits(["close"]);

function updateService() {
    props.team.service = settingsStore.getServices.filter((svc) => svc.id === props.team.service.id)[0];
}


</script>

<style scoped lang="scss">
.tile-card {
    overflow: auto;
    height: calc(100vh / 2);
}
</style>